import Vue from 'vue'
import { initializeApp } from 'firebase'
import config from './config'
import VueFire from 'vuefire'

Vue.use(VueFire)

const app = initializeApp(config.firebase)
export const auth = app.auth()
export const db = app.database()
export const usersRef = db.ref('/USERS')
export const catalogoRef = db.ref('/CATALOGO')
export const categoriesRef = db.ref('/CATEGORIAS')
export const productsRef = db.ref('/ARTICULOS')
export const shargoRef = db.ref('/SHARGO/ESCALADOS')



// WEBPACK FOOTER //
// ./src/firebase.js